import { ActivatedRoute, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '@auth/services/token-storage.service';
import { NavController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { inject } from '@angular/core';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';
import { UserContextService } from '../services/user-context.service';

export const createConnectedGuard = (redirectPath: string[] = ['/auth/login'], relativeToParent : boolean = false): CanActivateFn | CanActivateChildFn => {
  return async (route, state) => {
    const tokenStorage = inject(TokenStorageService);
    const userContext = inject(UserContextService);
    const router = inject(Router);

    let redirectPath2 = [...redirectPath];

    if (relativeToParent) {
      redirectPath2 = [...state.url.split('/').filter(Boolean).slice(0, -1), ...redirectPath2];
    }

    try {
      const token = await tokenStorage.getToken();

      if (!token) {
        return router.createUrlTree(redirectPath2);
      }

      const tokenIsExpirated = await tokenStorage.isExpired();

      if (tokenIsExpirated) {
        return router.createUrlTree(redirectPath2);
      }

      const user = await userContext.reloadCurrentUserIfNull();

      if (user == null) {
        return router.createUrlTree(redirectPath2);
      }

      return true;
    }
    catch (e) {
      return router.createUrlTree(redirectPath2);
    }
  };
};
